export type Role =
  | "super_admin"
  | "org_admin"
  | "site_manager"
  | "drill_supervisor"
  | "earthworks_supervisor"
  | "operator"
  | "viewer";

export type AppSlug = "operator" | "dashboard" | "earthworks" | "blasting" | "maintenance";

export type Permission =
  | "view:dashboard"
  | "view:drilling"
  | "view:earthworks"
  | "view:all_orgs"
  | "view:all_sites"
  | "view:own_site"
  | "manage:org"
  | "manage:users"
  | "manage:apps"
  | "input:shifts"
  | "input:own_shifts"
  | "approve:shifts";

export const ROLE_PERMISSIONS: Record<Role, Permission[]> = {
  super_admin: [
    "view:dashboard",
    "view:drilling",
    "view:earthworks",
    "view:all_orgs",
    "view:all_sites",
    "manage:org",
    "manage:users",
    "manage:apps",
    "input:shifts",
    "approve:shifts",
  ],
  org_admin: [
    "view:dashboard",
    "view:drilling",
    "view:earthworks",
    "view:all_sites",
    "manage:org",
    "manage:users",
    "manage:apps",
    "input:shifts",
    "approve:shifts",
  ],
  site_manager: [
    "view:dashboard",
    "view:drilling",
    "view:earthworks",
    "view:own_site",
    "manage:users",
    "input:shifts",
    "approve:shifts",
  ],
  drill_supervisor: [
    "view:dashboard",
    "view:drilling",
    "view:own_site",
    "input:shifts",
    "approve:shifts",
  ],
  earthworks_supervisor: [
    "view:dashboard",
    "view:earthworks",
    "view:own_site",
    "input:shifts",
  ],
  operator: [
    "view:dashboard",
    "view:own_site",
    "input:own_shifts",
  ],
  viewer: [
    "view:dashboard",
    "view:drilling",
    "view:earthworks",
    "view:own_site",
  ],
};

export const ROLE_LABELS: Record<Role, string> = {
  super_admin: "Super Admin",
  org_admin: "Organisation Admin",
  site_manager: "Site Manager",
  drill_supervisor: "Drill Supervisor",
  earthworks_supervisor: "Earthworks Supervisor",
  operator: "Operator",
  viewer: "Viewer",
};

export interface UserProfile {
  id: string;
  user_id: string;
  org_id: string;
  role: Role;
  site_ids: string[];
  full_name: string | null;
  avatar_url: string | null;
  created_at: string;
  updated_at: string;
}

export interface Organisation {
  id: string;
  name: string;
  slug: string;
  logo_url: string | null;
  created_at: string;
}

export interface OrgApp {
  id: string;
  org_id: string;
  app_slug: AppSlug;
  enabled: boolean;
  created_at: string;
}
